import { Flex, Text } from '@chakra-ui/react';
import { faCalendar, faClock } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, OutlineCard } from '@morressier/alembic';
import { IRevisionRound } from '@publishing-engine/domain/models';
import MultilineText from 'src/components/MultilineText';
import { formatDate, timeFormatDeadlineDate } from 'src/utils/date';
import string from 'src/utils/string';
import { ReviewerFeedback } from './ReviewerFeedback';
import { AdjudicatorFeedback } from './AdjudicatorFeedback';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import FileViewerButtonText from 'src/components/Submission/FileViewerButtonText';

export const RevisionFeedback = ({
  revisionRound,
  currentDeadline,
  submissionId
}: {
  revisionRound: IRevisionRound;
  currentDeadline: Date | undefined;
  submissionId: string;
}) => (
  <Flex flexDirection="column" gap={8}>
    <OutlineCard padding={4} width="100%">
      <Flex flexDirection="column" gap={6}>
        {revisionRound.severity ? (
          <>
            <Text textStyle="headingSection">Revision Request</Text>
            <Banner
              variant="attention"
              heading={string.capitalize(
                `${revisionRound.severity} revision requested`
              )}
            />
          </>
        ) : (
          <Banner
            variant="attention"
            heading={'Revision requested'}
          />
        )}

        <Flex flexDirection="column" gap={2}>
          <Flex flexDirection="row" gap={2} alignItems="center">
            <FontAwesomeIcon icon={faCalendar} />
            Received {formatDate(new Date(revisionRound.dateEntered))}
          </Flex>
          {currentDeadline && (
            <Flex flexDirection="row" gap={2} alignItems="center">
              <FontAwesomeIcon icon={faClock} />
              Deadline {timeFormatDeadlineDate(currentDeadline)}
            </Flex>
          )}
        </Flex>
        {revisionRound.editorialComment && (
          <Flex gap={2} flexDirection={'column'}>
            <Text textStyle="headingGroup">Editor’s comment</Text>
            <MultilineText
              textStyle="textBody"
              text={revisionRound.editorialComment}
            />
          </Flex>
        )}
        {revisionRound.editorialAttachments &&
          revisionRound.editorialAttachments.length > 0 && (
            <Flex gap={2} flexDirection={'column'}>
              <Text textStyle="headingGroup">Editor’s attachments</Text>
              <Flex flexDirection="column" gap={0}>
                {' '}
                {revisionRound.editorialAttachments.map(file => (
                  <Flex
                    justifyContent="space-between"
                    key={file?.referenceName}
                  >
                    <Flex gap={2} alignItems="center">
                      <FontAwesomeIcon icon={faFile} />
                      <Text textStyle="textBody">{file?.referenceName}</Text>
                      <FileViewerButtonText
                        file={file}
                        submissionContextId={submissionId}
                        textStyle="textBody"
                        flexShrink={0}
                      >
                        View
                      </FileViewerButtonText>
                    </Flex>
                  </Flex>
                ))}
              </Flex>
            </Flex>
          )}

        {(() => {
          const reviewerFeedback = !revisionRound.reviewerRevisionFeedback
            ?.length
            ? revisionRound.reviewerOriginalFeedback ?? []
            : revisionRound.reviewerRevisionFeedback;

          return (
            <ReviewerFeedback
              reviewerFeedback={reviewerFeedback}
              submissionContextId={submissionId}
            />
          );
        })()}

        {(() => {
          const adjudicatorFeedback = revisionRound.adjudicatorOriginalFeedback
            ?.length
            ? revisionRound.adjudicatorOriginalFeedback
            : [];

          return (
            <AdjudicatorFeedback
              adjudicatorFeedback={adjudicatorFeedback}
              submissionContextId={submissionId}
            />
          );
        })()}
      </Flex>
    </OutlineCard>
  </Flex>
);
